var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesChatmessagesChat1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.52733C14 10.5533 11.3013 12.982 8 12.982C7.57266 12.982 7.15666 12.94 6.754 12.8627",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39933 11.884C2.94667 10.8907 2 9.316 2 7.52733",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39935 11.884C4.39868 12.4533 4.40001 13.2213 4.40001 14.0273",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.52733C2 4.50133 4.69867 2.07333 8 2.07333C11.3013 2.07333 14 4.502 14 7.528",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75333 12.86L4.39999 14.0267",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11787 7.5488C8.18296 7.61389 8.18296 7.71942 8.11787 7.7845C8.05278 7.84959 7.94726 7.84959 7.88217 7.7845C7.81708 7.71942 7.81708 7.61389 7.88217 7.5488C7.94726 7.48371 8.05278 7.48371 8.11787 7.5488",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7845 7.5488C10.8496 7.61389 10.8496 7.71942 10.7845 7.7845C10.7194 7.84959 10.6139 7.84959 10.5488 7.7845C10.4837 7.71942 10.4837 7.61389 10.5488 7.5488C10.6139 7.48371 10.7194 7.48371 10.7845 7.5488",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45118 7.5488C5.51627 7.61389 5.51627 7.71942 5.45118 7.7845C5.3861 7.84959 5.28057 7.84959 5.21548 7.7845C5.15039 7.71942 5.15039 7.61389 5.21548 7.5488C5.28057 7.48371 5.3861 7.48371 5.45118 7.5488",
    stroke: "#949BA5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesChatmessagesChat1);
export default __webpack_public_path__ + "static/media/messages-chatmessages-chat1.f68155f2603aec190a626f42942953e1.svg";
export { ForwardRef as ReactComponent };